import { render } from "./BookingsOrganizer.vue?vue&type=template&id=69407f0d"
import script from "./BookingsOrganizer.vue?vue&type=script&lang=js"
export * from "./BookingsOrganizer.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\oi\\Desktop\\TFC\\runpixie_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__